import styled from 'styled-components';

// /forgot-password reusa o shell visual do /login (Stage / BrandSide /
// FormSide / FormWrap / FormHead / Form / Submit / FormFoot). Pra evitar
// duplicar styled, importamos do styled-login direto. Caso o design das
// 2 telas divirja no futuro, basta substituir aqui pelas defs proprias.
//
// Re-exportadas pra que forgot-password-email.js consuma via 's.*'.
export {
  Stage,
  BrandSide,
  BrandBg,
  BrandOverlay,
  BrandTop,
  BrandMark,
  BrandHero,
  Eyebrow,
  HeroTitle,
  HeroLead,
  StatusRow,
  StatusCell,
  BrandFoot,
  FormSide,
  FormWrap,
  FormHead,
  FormHeadLbl,
  FormTitle,
  FormSub,
  Form,
  Field,
  FieldLabel,
  Ctrl,
  Hint,
  CapsLockHint,
  Submit,
  FormFoot,
  Vers,
} from '../login/styled-login';

// Botao 'Voltar ao login' — link ghost com seta esquerda, abaixo do
// Submit. Estilo discreto pra nao competir com a CTA principal.
export const BackToLogin = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
  color: var(--cco-ink-faint);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.15s;
  cursor: pointer;

  > svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    color: #1cb0d8;
  }
  &:focus-visible {
    outline: none;
    color: #1cb0d8;
  }
`;

// Mensagem de sucesso (apos email enviado, antes do history.push pra
// /forgot-password/verify) — toast inline verde discreto. Nao usado
// hoje (transition imediata) mas exportado pra futuras melhorias.
export const SuccessHint = styled.div`
  font-size: 11.5px;
  color: #2bd47d;
  font-weight: 500;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 6px;

  > svg {
    width: 14px;
    height: 14px;
  }
`;
